import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  EnvironmentInjector,
  EventEmitter,
  input,
  Input,
  model,
  OnInit,
  output,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Types } from 'shared-lib';
import {
  EIcon,
  EComponentSize,
  ELabelType,
  IComponentSection,
  FormItem,
  FilterSectionItem,
} from '../../types';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../label/label.component';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';
import { LoadingService } from '../loading/loading.service';
import { SectionComponent } from '../section/section.component';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';

@Component({
  selector: 'ui-filter',
  standalone: true,
  imports: [CommonModule, LabelComponent, ButtonComponent, IconComponent, DynamicFormComponent],
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
  fields = input.required<IComponentSection[]>();
  vertical = input(false);
  background = model<Types.EAlert>(Types.EAlert.DARK);

  valueChange = output<{ [key: string]: any }>();

  isPopupOpen: boolean = false;
  isMobile: boolean = false;
  ELabelType = ELabelType;
  EIcon = EIcon;
  EComponentSize = EComponentSize;
  EAlert = Types.EAlert;
  filters: { [key: string]: any } = {};

  constructor(
    private envInjector: EnvironmentInjector,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.fillFields();
    this.isMobile = this.checkIfMobile();
    window.addEventListener('resize', this.onResize);
    window.addEventListener('keydown', this.onKeydown);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('keydown', this.onKeydown);
  }

  onKeydown = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') {
      if (!this.vertical() || this.isMobile) {
        this.closeFilterPopup();
      }
    }
  };


  fillFields() {
    if (Object.keys(this.filters).length > 0) {
      // Itera sobre os filtros
      for (const [key, value] of Object.entries(this.filters)) {
        // Itera sobre os seletores dentro do filtro
        for (const selector in value) {
          const item = value[selector];

          // Verifica se a chave existe em 'item'
          if (item) {
            // Procura pelo componente com o mesmo seletor
            for (let section of this.fields()) {
              for (let component of section.content) {
                if (component.selector === selector) {
                  component.inputs.value = item;
                }
              }
            }
          }
        }
      }
    }
  }



  onResize = () => {
    this.isMobile = this.checkIfMobile();
    if (!this.isMobile || this.vertical()) {
      this.isPopupOpen = false;
    }
  };

  getBackgroundColor(): string {
    switch (this.background()) {
      case Types.EAlert.DANGER:
        return 'bg-red-500';
      case Types.EAlert.SUCCESS:
        return 'bg-green-500';
      case Types.EAlert.WARNING:
        return 'bg-yellow-500';
      case Types.EAlert.DARK:
        return 'bg-gray-800';
      case Types.EAlert.LIGHT:
        return 'bg-white-800';
      default:
        return 'bg-blue-500';
    }
  }

  getBorderStyle(): string {
    switch (this.background()) {
      case Types.EAlert.DANGER:
        return 'border-red-700';
      case Types.EAlert.SUCCESS:
        return 'border-green-700';
      case Types.EAlert.WARNING:
        return 'border-yellow-700';
      case Types.EAlert.DARK:
        return 'border-gray-700';
        case Types.EAlert.LIGHT:
          return 'border-white-700';
      default:
        return 'border-blue-700';
    }
  }

  applyFilters(event: any) {
    this.filters = event;
    this.valueChange.emit(this.filters);
    this.closeFilterPopup();
  }

  clearFilters() {
    this.filters = {};
    this.valueChange.emit(this.filters);
  }

  openPopup() {
    this.isPopupOpen = !this.isPopupOpen;
    this.fillFields();
  }

  closeFilterPopup() {
    this.isPopupOpen = false;
  }

  checkIfMobile(): boolean {
    return window.innerWidth <= 768;
  }

  get shouldShowButton(): boolean {
    return !this.vertical() || window.innerWidth <= 768;
  }
}
